// Copyright 2026. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';
import { COLORS } from 'admin/core/theme';

export const CardItemContainer = styled.div`
    height: 100%;

    .pul-item {
        height: 100%;
        box-sizing: border-box;
    }
`;

export const SankeyHeader = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 32px;
    width: 100%;
    margin-bottom: 8px;
`;

export const SankeyHeaderTitle = styled.span`
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    color: #1a1a1a;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const SankeyTooltip = styled.div`
    position: fixed;
    background: rgba(0, 0, 0, 0.75);
    color: ${COLORS.WHITE};
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 12px;
    pointer-events: none;
    z-index: 9999;
    white-space: nowrap;
`;

export const StorageName = styled.a`
    display: block;
    padding: 4px 0;
    font-size: 13px;
    color: ${COLORS.BLUE_10};
    text-decoration: none;
    &:hover {
        text-decoration: underline;
    }
`;

export const StorageContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
`;

export const LegendRow = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    font-size: 13px;
    color: ${COLORS.GREY_80};
    padding: 4px 0;
    border-top: 1px solid ${COLORS.GREY_20};
`;

export const LegendLabel = styled.span`
    display: flex;
    align-items: center;
    flex: 1;
`;

export const LegendValue = styled.span`
    color: ${COLORS.GREY_70};
    font-size: 12px;
`;

export const IpBlockRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    padding: 4px 0;
    border-bottom: 1px solid ${COLORS.GREY_20};

    &:last-child {
        border-bottom: none;
    }
`;

export const IpBlockLink = styled.a`
    color: ${COLORS.BLUE_10};
    font-weight: 500;
    text-decoration: none;
    font-size: 13px;
    &:hover {
        text-decoration: underline;
    }
`;

export const IpBlockUsage = styled.span`
    color: ${COLORS.GREY_70};
    font-size: 12px;
`;

export const EmptyCardText = styled.div`
    font-size: 13px;
    color: ${COLORS.GREY_60};
    text-align: center;
    padding: 12px 0;
`;

export const StackedCardsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    height: 100%;
`;

export const ActivityCount = styled.div`
    font-size: 28px;
    font-weight: 600;
    line-height: 36px;
    color: #1a1a1a;
    padding: 8px 0;
`;

